export default {
  engineering_mechanical: {
    en: 'Mechanical Engineering',
    fr: 'Génie Mécanique',
  },
  engineering_electrical: {
    en: 'Electrical Engineering',
    fr: 'Génie Électrique',
  },
  engineering_software: {
    en: 'Software Engineering',
    fr: 'Génie Logiciel',
  },
  engineering_construction: {
    en: 'Construction Engineering',
    fr: 'Génie de la Construction',
  },
  engineering_gpa: {
    en: 'Automated Production Engineering',
    fr: 'Génie de la Production Automatisée',
  },
  engineering_gol: {
    en: 'Operations and Logistics Engineering',
    fr: 'Génie des Opérations et de la Logistique',
  },
  engineering_software_master: {
    en: 'Master in Software Engineering',
    fr: 'Maîtrise en Génie Logiciel',
  },
  gti_master: {
    en: 'Master of Information Technology Engineering',
    fr: "Maitrise en génie des technologies de l'information",
  },
  master: {
    en: 'Master',
    fr: 'Maitrise',
  },
  master_aero: {
    en: 'Master of Aerospace',
    fr: 'Maitrise en Aérospatial',
  },
};
